import { MapPin, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface DistanceDisplayProps {
  distance: number | null;
  onClick: () => void;
  className?: string;
}

export default function DistanceDisplay({
  distance,
  onClick,
  className,
}: DistanceDisplayProps) {
  const formatDistanceShort = (dist: number | null): string => {
    if (dist === null) {
      return 'Any';
    }
    if (Number.isInteger(dist)) {
      return `${dist} mi`;
    }
    return `${dist.toFixed(1)} mi`;
  };

  const formatDistanceFull = (dist: number | null): string => {
    if (dist === null) {
      return 'Any distance';
    }
    if (Number.isInteger(dist)) {
      return `Within ${dist} mi`;
    }
    return `Within ${dist.toFixed(1)} mi`;
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      className={cn(
        "flex items-center gap-1 text-xs font-medium rounded-full flex-shrink-0",
        distance !== null && "bg-primary/5 border-primary/30 text-primary",
        className
      )}
      aria-label={formatDistanceFull(distance)}
      data-testid="distance-display-badge"
    >
      <MapPin className="w-3 h-3" />
      <span className="sm:hidden">{formatDistanceShort(distance)}</span>
      <span className="hidden sm:inline">{formatDistanceFull(distance)}</span>
      <ChevronDown className="w-3 h-3 opacity-60" />
    </Button>
  );
}
